module.exports = __webpack_public_path__ + "static/media/chat_notify.dac7e4e7.mp3";